// RemovePallet.js
import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import { useLoading } from '../utils/loading/LoadingContext';
import LoadingIndicator from '../utils/loading/LoadingIndicator';
import 'react-toastify/dist/ReactToastify.css';

const RemoveFromPallet = () => {
    const { palletNumber } = useParams(); // Get pallet number from the URL
    const [identifier, setIdentifier] = useState('');
    const [removedBols, setRemovedBols] = useState([]);
    const [lastBolStatus, setLastBolStatus] = useState('');
    const baseUrl = process.env.REACT_APP_DJANGO_API_BASE_URL;
    const { isLoading, setLoading } = useLoading();
    const navigate = useNavigate();

    const handleRemove = (e) => {
        e.preventDefault();
        setLoading(true);
        fetch(`${baseUrl}/api/pallet_scan/`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                pallet_number: palletNumber,
                identifier,
                action: 'remove'
            }),
        })
            .then(response => response.json())
            .then(data => {
                setRemovedBols(data.processed_bols);
                setLastBolStatus(data.last_bol_status);
                toast.success('Item removed successfully');
                setIdentifier('');
                setLoading(false);
            })
            .catch(error => {
                console.error('Error removing item:', error);
                toast.error('Failed to remove item');
                setLoading(false);
            });
    };

    return (
        <div className="removePallet-body">
            {isLoading && <LoadingIndicator />}
            <h2>Remove from Pallet {palletNumber}</h2>
            <form onSubmit={handleRemove}>
                <input
                    type="text"
                    value={identifier}
                    onChange={(e) => setIdentifier(e.target.value)}
                    placeholder="Enter BOL or PkgID to remove"
                    required
                />
                <button type="submit">Remove</button>
            </form>
            <div className="removed-bols">
                <h3>Recently Removed BOLs</h3>
                <ul>
                    {removedBols.map((bol, index) => (
                        <li key={index}>{bol}</li>
                    ))}
                </ul>
            </div>
            <ToastContainer />
        </div>
    );
};

export default RemoveFromPallet;
